import { TypographyVariant, FontWeight } from './TypographyTypes';

// Font size mapping for Typography variants
export const variantMapping: Record<TypographyVariant, string> = {
  h1: '48px',
  h2: '32px',
  h3: '24px',
  h4: '20px',
  subtitle1: '18px',
  subtitle2: '16px',
  subtitle3: '14px',
  body1: '16px',
  body2: '14px',
  caption1: '12px',
  caption2: '11px',
  overline1: '12px',
  overline2: '11px',
  overline3: '10px',
};

// Font weight mapping
export const fontWeightMapping: Record<FontWeight, string> = {
  extralight: '200',
  regular: '400',
  medium: '500',
  bold: '700',
  extrabold: '800',
};

// Default font weight mapping for each variant
export const variantDefaultFontWeight: Record<TypographyVariant, FontWeight> = {
  h1: 'bold',
  h2: 'bold',
  h3: 'bold',
  h4: 'bold',
  subtitle1: 'bold',
  subtitle2: 'bold',
  subtitle3: 'bold',
  caption1: 'medium',
  caption2: 'medium',
  body1: 'regular',
  body2: 'regular',
  overline1: 'bold',
  overline2: 'bold',
  overline3: 'bold',
};

// Default line height mapping for each variant
export const variantDefaultLineHeight: Record<TypographyVariant, string> = {
  h1: '56px',
  h2: '40px',
  h3: '32px',
  h4: '32px',
  subtitle1: '32px',
  subtitle2: '24px',
  subtitle3: '24px',
  overline1: '24px',
  overline2: '24px',
  overline3: '16px',
  caption1: '16px',
  caption2: '16px',
  body1: '24px',
  body2: '22px',
};
